import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, MapPin, Phone, Clock } from "lucide-react";
import { CATEGORIES } from "../data/store";
import { toast } from "sonner";

export const Footer = () => (
  <footer className="bg-[#111111] text-white mt-16">
    <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div>
        <div className="text-xl font-extrabold text-white">E-Commerce <span className="text-[#FF3B44]">DEMO</span></div>
        <p className="text-sm text-white/60 mt-2">Saimniecības, higiēnas un tīrīšanas preču interneta veikala demonstrācija — B2B un B2C.</p>
        <div className="mt-4 space-y-2 text-sm text-white/70">
          <div className="flex items-center gap-2"><MapPin size={14} /> Demo iela 1, Demo pilsēta, LV-0000</div>
          <div className="flex items-center gap-2"><Phone size={14} /> +371 20 000 000</div>
          <div className="flex items-center gap-2"><Mail size={14} /> info@ecommercedemo.lv</div>
          <div className="flex items-center gap-2"><Clock size={14} /> Darba dienās 8:00–17:00</div>
        </div>
      </div>
      <div>
        <h4 className="text-sm font-bold uppercase tracking-widest text-white/50 mb-3">Kategorijas</h4>
        <ul className="space-y-2 text-sm">
          {CATEGORIES.map((c) => (
            <li key={c.slug}><Link to={`/kategorija/${c.slug}`} className="text-white/80 hover:text-white hover:underline">{c.name}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-bold uppercase tracking-widest text-white/50 mb-3">Klientu serviss</h4>
        <ul className="space-y-2 text-sm text-white/80">
          <li><Link to="/par-mums" className="hover:text-white hover:underline">Par mums / Kontakti</Link></li>
          <li><Link to="/vairumtirdznieciba" className="hover:text-white hover:underline">Vairumtirdzniecība</Link></li>
          <li><Link to="/zimoli" className="hover:text-white hover:underline">Zīmoli</Link></li>
          <li><Link to="/akcijas" className="hover:text-white hover:underline">Akcijas</Link></li>
          <li><span className="hover:text-white">Piegāde un atgriešana</span></li>
          <li><span className="hover:text-white">Privātuma politika</span></li>
          <li><Link to="/admin" data-testid="footer-admin-link" className="text-[#FF3B44] font-bold hover:underline">Admin panelis (DEMO)</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-bold uppercase tracking-widest text-white/50 mb-3">Jaunumu abonēšana</h4>
        <p className="text-sm text-white/60 mb-3">Saņem akcijas un jaunumus e-pastā.</p>
        <form onSubmit={(e) => { e.preventDefault(); toast.success("Paldies! Abonements noformēts."); e.target.reset(); }} className="flex gap-2">
          <input type="email" required placeholder="Tavs e-pasts" data-testid="newsletter-email-input"
            className="flex-1 h-10 px-3 rounded-md bg-white/10 border border-white/20 text-sm placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-[#D0121A]" />
          <button type="submit" data-testid="newsletter-submit" className="bg-[#D0121A] hover:bg-[#A80D14] text-white text-sm font-bold px-4 rounded-md transition-colors">Abonēt</button>
        </form>
        <div className="flex gap-3 mt-5">
          <a href="#fb" aria-label="Facebook" className="p-2 bg-white/10 rounded-md hover:bg-white/20 transition-colors"><Facebook size={16} /></a>
          <a href="#ig" aria-label="Instagram" className="p-2 bg-white/10 rounded-md hover:bg-white/20 transition-colors"><Instagram size={16} /></a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 py-4 text-xs text-white/40 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} E-Commerce DEMO · Demo reģ. nr. 40000000000 · Demo pilsēta</span>
        <span>Cenas norādītas ar PVN 21%</span>
      </div>
    </div>
  </footer>
);
